import { create } from "zustand";
import { mediaUrl, API } from "../lib/api";

const audio = typeof Audio !== "undefined" ? new Audio() : null;
if (audio) audio.volume = 0.8;

const logPlay = (() => {
  const counted = new Set();
  return (id) => {
    if (!id || counted.has(id)) return;
    counted.add(id);
    try { fetch(`${API}/public/tracks/${id}/play`, { method: "POST", keepalive: true }); } catch (e) {}
  };
})();

export const getAudioEl = () => audio;

export const useAudio = create((set, get) => ({
  queue: [],
  index: -1,
  isPlaying: false,
  currentTime: 0,
  duration: 0,
  volume: 0.8,
  open: false,          // player bar visible (after first LISTEN)
  fullscreen: false,
  embedTrack: null,     // when an EXTERNAL EMBED track is selected

  current: () => {
    const { queue, index } = get();
    return index >= 0 ? queue[index] : null;
  },

  playList: (tracks, startIndex = 0) => {
    const owned = tracks;
    const t = owned[startIndex];
    if (!t) return;
    set({ queue: owned, open: true });
    get().playAt(startIndex);
  },

  playAt: (i) => {
    const { queue } = get();
    const t = queue[i];
    if (!t) return;
    logPlay(t.id);
    if (t.source_type === "embed") {
      if (audio) audio.pause();
      set({ index: i, isPlaying: false, embedTrack: t, open: true });
      return;
    }
    set({ embedTrack: null, index: i, open: true });
    if (audio) {
      audio.src = mediaUrl(t.audio_url);
      audio.play().then(() => set({ isPlaying: true })).catch(() => set({ isPlaying: false }));
    }
  },

  toggle: () => {
    const t = get().current();
    if (!t || !audio) return;
    if (t.source_type === "embed") return;
    if (audio.paused) { audio.play(); set({ isPlaying: true }); }
    else { audio.pause(); set({ isPlaying: false }); }
  },

  next: () => {
    const { index, queue } = get();
    if (queue.length === 0) return;
    get().playAt((index + 1) % queue.length);
  },

  prev: () => {
    const { index, queue } = get();
    if (queue.length === 0) return;
    get().playAt((index - 1 + queue.length) % queue.length);
  },

  seek: (t) => { if (audio) { audio.currentTime = t; set({ currentTime: t }); } },
  setVolume: (v) => { if (audio) audio.volume = v; set({ volume: v }); },
  setFullscreen: (b) => set({ fullscreen: b }),
  _setTime: (currentTime, duration) => set({ currentTime, duration }),
  _setPlaying: (b) => set({ isPlaying: b }),
}));
